import React, {useEffect, useState, useRef} from 'react';
import Axios from 'axios';
import { Alert } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import '../App.css';
import Pagination from '../components/global/Paginator'
import Pagination1 from '../components/global/Paginator1'

function Grillabocambios (props){
    const [show, setShow] = useState(false);
    const [datos, setDatos] = useState([]);
    const [datosApoderados, setDatosApoderados] = useState([]);

    const [fecha, setFecha] = useState('')
    const [visible, setVisible] = useState('seccionNoVisible')
    const [beneficiario, setBeneficiario] = useState()
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);  
    const [tituloAlert1, setTituloAlert1] = useState('')
    const [textoAlert1, setTextoAlert1] = useState('')
    const [claseAlert1, setClaseAlert1] = useState('')    
    const [alert1, setAlert1] = useState(false);

    const [tituloAlert3, setTituloAlert3] = useState('')
    const [textoAlert3, setTextoAlert3] = useState('')
    const [claseAlert3, setClaseAlert3] = useState('')    
    const [alert3, setAlert3] = useState(false);

    const [pageNumber, setPageNumber] = useState('')
    const [pageSize, setPageSize] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumberApoderados, setPageNumberApoderados] = useState('')
    
    const [pageSizeApoderados, setPageSizeApoderados] = useState(3);
    const [totalPagesApoderados, setTotalPagesApoderados] = useState(1);
    const [casinoSeleccionado, setCasinoSeleccionado] = useState();   
    const [rutAlumno, setRutAlumno] = useState();   
    const [nombreAlumno, setNombreAlumno] = useState();
    const [casinoApoderadoSeleccionado, setCasinoApoderadoSeleccionado] = useState();   
    const [rutApoderado, setRutApoderado] = useState();   
    const [usuarioApoderado, setUsuarioApoderado] = useState();    
    const [currentPage, setCurrentPage] = useState(1);   
    const [currentPageApoderados, setCurrentPageApoderados] = useState(1); 
    const [casinos, setCasinos] = useState([])  
    const [alumnoCheck, setAlumnoCheck] = useState([]);
    const [apoderadoCheck, setApoderadoCheck] = useState([]);

    const handleNombreAlumnoChange = (e) => {
        setNombreAlumno(e.target.value)
    }

    const handleRutApoderadoChange = (e) => {
        setRutApoderado(e.target.value)
    }

    const handleCasinoApoderadoSeleccionadoChange = (e) => {
        setCasinoApoderadoSeleccionado(e.target.value)
    }
    
    const handleUsuarioApoderadoChange = (e) => {
        setUsuarioApoderado(e.target.value)
    }

    const handleRutAlumnoChange = (e) => {
        setRutAlumno(e.target.value)
    }

    const handleCasinoChange = (e) => {
        setCasinoSeleccionado(e.target.value)
    }

   
    const dataList = datos.map((item, i) => 
<div key={i} className="bg-gray-100 p-4 rounded-md shadow mt-4">
  <h3 className="text-sm font-semibold text-gray-800 mb-3">Detalles del Alumno</h3>

  {/* Flex contenedor para columnas, se envuelven si no hay espacio */}
  <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs">

    {/* Índice */}
    <div className="flex items-center space-x-1">
      <span className="bg-indigo-600 text-white px-2 py-0.5 rounded-md font-bold text-sm">{i + 1}</span>
    </div>

    {/* RUT Alumno */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">RUT Alumno:</span>
      <span className="font-semibold text-gray-800">{item.rut_alumno}</span>
    </div>

    {/* Nombre Alumno */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">Nombre:</span>
      <span className="font-semibold text-gray-800">{item.primer_nombre} {item.segundo_nombre} {item.primer_apellido} {item.segundo_apellido}</span>
    </div>

    {/* Usuario Apoderado */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">Usuario Apoderado:</span>
      <span className="font-semibold text-gray-800">{item.usuario_apoderado}</span>
    </div>

    {/* Nombre Apoderado */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">Apoderado:</span>
      <span className="font-semibold text-gray-800">{item.nombre_apoderado} {item.apellido_apoderado}</span>
    </div>

    {/* RUT Apoderado */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">RUT Apoderado:</span>
      <span className="font-semibold text-green-800">{item.rut_apoderado}</span>
    </div>

    {/* Casino */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">Casino:</span>
      <span className="font-semibold text-green-800">{item.nombre_casino}</span>
    </div>

    {/* Checkbox Selección */}
    <div className="flex items-center space-x-1">
      <input
        type="checkbox"
        onClick={() => selectAlumno(item)}
        className="form-checkbox h-4 w-4 text-indigo-600"
      />
      <span className="text-gray-700">Seleccionar</span>
    </div>
  </div>
</div>);

    const dataListApoderados =  datosApoderados.map((item, i) => 
<div key={i} className="bg-gray-100 p-4 rounded-md shadow mt-4">
  <h3 className="text-sm font-semibold text-gray-800 mb-3">Detalles del Apoderado</h3>

  <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs">

    {/* Índice */}
    <div className="flex items-center space-x-1">
      <span className="bg-indigo-600 text-white px-2 py-0.5 rounded-md font-bold text-sm">{i + 1}</span>
    </div>

    {/* Usuario Apoderado */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">Usuario Apoderado:</span>
      <span className="font-semibold text-gray-800">{item.mail}</span>
    </div>

    {/* Rut Apoderado */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">RUT:</span>
      <span className="font-semibold text-gray-800">{item.rut_apoderado}</span>
    </div>

    {/* Nombre Apoderado */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">Nombre:</span>
      <span className="font-semibold text-gray-800">{item.nombre_apoderado} {item.apellido_apoderado}</span>
    </div>

    {/* Casino */}
    <div className="flex items-center space-x-1">
      <span className="font-medium text-gray-500">Casino:</span>
      <span className="font-semibold text-gray-800">{item.nombre_casino}</span>
    </div>

    {/* Checkbox Selección */}
    <div className="flex items-center space-x-1">
      <input
        type="checkbox"
        onClick={() => selectApoderado(item)}
        className="form-checkbox h-4 w-4 text-indigo-600"
      />
      <span className="text-gray-700">Seleccionar</span>
    </div>
  </div>
</div>
);

    const selectAlumno = (e) => {
        setAlumnoCheck(e)
    }

    const selectApoderado = (e) => {
        setApoderadoCheck(e)
    }

    const AsignaApoderado = () => {
        setShow(true);
    }

    const GetAlumnos = () =>
    {
        Axios.get(process.env.REACT_APP_URLTICKETLISTARALUMNOSQUERY, {
            params: {
                page: pageNumber || 1,
                pageSize: pageSize || 10,
                casino_id: casinoSeleccionado,
                rut_alumno: rutAlumno || "",
                nombre_alumno: nombreAlumno || ""
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data.alumnos)
            setCurrentPage(response.data.alumnos_metadata.currentPage)
            setPageNumber(response.data.alumnos_metadata.currentPage)
            setTotalPages(response.data.alumnos_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    }

    const GetApoderados = () =>
        {
            Axios.get(process.env.REACT_APP_URLTICKETLISTARAPODERADOSQUERY, {
                params: {
                    page: pageNumber || 1,
                    pageSize: pageSize || 10,
                    casino_id: casinoApoderadoSeleccionado,
                    rut_apoderado: rutApoderado || "",
                    usuario_apoderado: usuarioApoderado || ""
                }, 
                headers: {
                    'Access-Control-Allow-Origin' : '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type'
                }
            }).then((response) => {
                setDatosApoderados(response.data.apoderados)
                setCurrentPageApoderados(response.data.apoderados_metadata.currentPage)
                setPageNumberApoderados(response.data.apoderados_metadata.currentPage)
                setTotalPagesApoderados(response.data.apoderados_metadata.totalPages)
            }).catch(error => {
                return error     
            });
    }

    const GetCasinos = () => {
        Axios.get(process.env.REACT_APP_URLCASINO, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setCasinos(response.data)
        }).catch(error => {
            return error     
        });        
    }

    const asignarApoderadoAPI = () =>{
        Axios.put(
            process.env.REACT_APP_URLTICKETASIGNARAPODERADO,
            {
              user_id: apoderadoCheck.mail, 
              beneficiary_id: alumnoCheck.id
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
              }
            }
          ).then((response) => {
                setTituloAlert('Asignacion de apoderado')
                setTextoAlert(response.message)
                setClaseAlert('success')
                setAlert(true)
                setDatos([])
                setDatosApoderados([])
                setTimeout(() => {    
                    setAlert(false)
                    setShow(false)
                }, 3000)                
          }).catch(error => {
            console.error(error);
          });        
    }

    useEffect(() => {
        GetAlumnos()
        GetCasinos()
    }, [pageNumber]);

    useEffect(() => {
        GetApoderados()
    }, [pageNumberApoderados]);

    const handleClose = () => {
        setBeneficiario('')
        setFecha('')
        setShow(false)
    }

    return(
    <div className='w-full space-y-4 px-4'>        
  {/* Fila 1: Alumnos y sus resultados */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

    {/* Zona 1 - Filtros Alumnos */}
    <div className="bg-white shadow-lg p-4">
      <h2 className="text-sm font-semibold mb-2">Alumnos</h2>
      <div className="flex flex-col gap-2 text-xs">

        {/* Casino */}
        <div className="flex flex-col">
          <label htmlFor="casino" className="text-xs font-medium text-gray-600 mb-1">Casino</label>
          <select
            id="casino"
            value={casinoSeleccionado}
            onChange={handleCasinoChange}
            className="p-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500"
          >
            <option value="">Seleccione Casino</option>
            {casinos.map((casino) => (
              <option key={casino.id} value={casino.id}>{casino.nombre}</option>
            ))}
          </select>
        </div>

        {/* RUT */}
        <div className="flex flex-col">
          <label htmlFor="rutAlumno" className="text-xs font-medium text-gray-600 mb-1">RUT Alumno</label>
          <input
            type="text"
            id="rutAlumno"
            value={rutAlumno}
            onChange={handleRutAlumnoChange}
            placeholder="Ej: 12345678-9"
            className="p-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500"
          />
        </div>

        {/* Nombre */}
        <div className="flex flex-col">
          <label htmlFor="nombreAlumno" className="text-xs font-medium text-gray-600 mb-1">Nombre Alumno</label>
          <input
            type="text"
            id="nombreAlumno"
            value={nombreAlumno}
            onChange={handleNombreAlumnoChange}
            placeholder="Ej: Juan Pérez"
            className="p-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500"
          />
        </div>

        {/* Botón */}
        <div className="flex flex-col">
          <button
            onClick={GetAlumnos}
            className="bg-indigo-600 text-white p-1 text-xs rounded-md shadow hover:bg-indigo-700 focus:outline-none focus:ring-1 focus:ring-indigo-500 flex items-center justify-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h2M15 3h-6a2 2 0 0 0-2 2v4h10V5a2 2 0 0 0-2-2z" />
            </svg>
            Buscar Alumno
          </button>
        </div>
      </div>
    </div>

    {/* Zona 2 - Resultados Alumnos */}
    <div className="bg-white shadow-lg p-4">
      <div className="overflow-y-auto h-[200px] p-2 text-xs">
        <div className="space-y-4">
          {dataList}
        </div>
      </div>
      <div className="w-full mt-2 flex justify-center">
        <Pagination id="paginator1"
            currentPage={pageNumber} 
            totalPages={totalPages} 
            onPageChange={setPageNumber} />
      </div>
    </div>
  </div>

  {/* Fila 2: Apoderados y sus resultados */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

    {/* Zona 3 - Filtros Apoderados */}
    <div className="bg-white shadow-lg p-4">
      <h2 className="text-sm font-semibold mb-2">Apoderados</h2>
      <div className="flex flex-col gap-2 text-xs">

        {/* Casino */}
        <div className="flex flex-col">
          <label htmlFor="casinoApoderado" className="text-xs font-medium text-gray-600 mb-1">Casino</label>
          <select
            id="casinoApoderado"
            value={casinoApoderadoSeleccionado}
            onChange={handleCasinoApoderadoSeleccionadoChange}
            className="p-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500"
          >
            <option value="">Seleccione Casino</option>
            {casinos.map((casino) => (
              <option key={casino.id} value={casino.id}>{casino.nombre}</option>
            ))}
          </select>
        </div>

        {/* RUT Apoderado */}
        <div className="flex flex-col">
          <label htmlFor="rutApoderado" className="text-xs font-medium text-gray-600 mb-1">RUT Apoderado</label>
          <input
            type="text"
            id="rutApoderado"
            value={rutApoderado}
            onChange={handleRutApoderadoChange}
            placeholder="Ej: 12345678-9"
            className="p-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500"
          />
        </div>

        {/* Usuario Apoderado */}
        <div className="flex flex-col">
          <label htmlFor="usuarioApoderado" className="text-xs font-medium text-gray-600 mb-1">Usuario Apoderado</label>
          <input
            type="email"
            id="usuarioApoderado"
            value={usuarioApoderado}
            onChange={handleUsuarioApoderadoChange}
            placeholder="Ej: jperez@gmail.com"
            className="p-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500"
          />
        </div>

        {/* Botones */}
        <div className="flex flex-col space-y-1">
          <button
            onClick={GetApoderados}
            className="bg-indigo-600 text-white p-1 text-xs rounded-md shadow hover:bg-indigo-700 focus:outline-none focus:ring-1 focus:ring-indigo-500 flex items-center justify-center"
          >
            Buscar Apoderado
          </button>
          <button
            onClick={AsignaApoderado}
            className="bg-indigo-600 text-white p-1 text-xs rounded-md shadow hover:bg-indigo-700 focus:outline-none focus:ring-1 focus:ring-indigo-500 flex items-center justify-center"
          >
            Asignar Apoderado
          </button>
        </div>
      </div>
    </div>

    {/* Zona 4 - Resultados Apoderados */}
    <div className="bg-white shadow-lg p-4">
      <div className="overflow-y-auto  h-[200px] p-2 text-xs">
        <div className="space-y-4">
          {dataListApoderados}
        </div>
      </div>
      <div className="w-full mt-2 flex justify-center">
        <Pagination1 id="paginator2"
          currentPage={pageNumberApoderados}
          totalPages={totalPagesApoderados}
          onPageChange={setPageNumberApoderados}
        />
      </div>
    </div>

  </div>


        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Asignacion de nuevo apoderado</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                        </Alert>
                        :''
                        }
                    </div>
                </div>

                <div className="space-y-6">
                    {/* Rut Cliente */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                        <label className="font-semibold text-gray-700">El Alumno RUT</label>
                        <div className="col-span-2">
                        <input
                            type="text"
                            value={alumnoCheck.rut_alumno}
                            disabled
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>
                    </div>

                    {/* Rut Beneficiario */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                        <label className="font-semibold text-gray-700">Nombre</label>
                        <div className="col-span-2">
                        <input
                            type="text"
                            value={alumnoCheck.primer_nombre + ' ' + alumnoCheck.primer_apellido}
                            disabled
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>
                    </div>

                    {/* Rut Beneficiario */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                        <label className="font-semibold text-gray-700">Del Casino</label>
                        <div className="col-span-2">
                        <input
                            type="text"
                            value={alumnoCheck.nombre_casino}
                            disabled
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>
                    </div>

                    {/* Fecha Consumo */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                        <label className="font-semibold text-gray-700">Será asignado al Apoderado con RUT</label>
                        <div className="col-span-2">
                        <input
                            type="text"
                            value={apoderadoCheck.rut_apoderado}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>
                    </div>

                    {/* Fecha Consumo */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                        <label className="font-semibold text-gray-700">Nombre</label>
                        <div className="col-span-2">
                        <input
                            type="text"
                            value={apoderadoCheck.nombre_apoderado}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
            <button
                onClick={handleClose}
                className="bg-red-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-200"
                >
                Cerrar
            </button>

            <button
                onClick={asignarApoderadoAPI}
                className="bg-indigo-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                Asignar
            </button>

            </Modal.Footer>
            <Modal.Footer className={visible}>
            <div>
                <h4>Debe completar todos los campos</h4>
            </div>
            </Modal.Footer>
        </Modal>                                                                                                                                                                                           
    </div>    
    )
}
export default Grillabocambios